export const isFunction = (x: unknown) => typeof x === "function";